import { render, staticRenderFns } from "./company-moreinfo-form.vue?vue&type=template&id=3ec7c38c"
import script from "./company-moreinfo-form.vue?vue&type=script&lang=js"
export * from "./company-moreinfo-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports